<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5> {{ $t('Device filter')}} </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
   
        <!-- <b-col md="12" sm="12" lg="6" class="mb-md-0 mb-2">
          <label>{{ $t('Category') }}</label>
          <v-select multiple
                   :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"
                    label="name"
                    :options="categoriesOptions.map(i=>({id:i,name:$t(i)}))"
                    v-model="filter_request.categories"
                    class="w-100"
                    v-on:input="filterDataChanged"
                    :reduce="val=>val.id"
          />
        </b-col> -->

        <b-col lg="4" md="12" class="mb-md-0 mb-2">
          <label>{{$t('Owners')}}</label>
          <v-select multiple :close-on-select="false"
                 :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"
                   
                    label="name"
                    :options="ownersOptions"
                    v-model="filter_request.owners"
                    class="w-100"
                    :reduce="val => val.id"
                    v-on:input="filterDataChanged"
          />
        </b-col>

        <b-col lg="4" md="12" class="mb-md-0 mb-2">
          <label>{{$t('types')}}</label>
          <v-select
              :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"              
              :options="typesOptions"
              :getOptionLabel="t => t.name"
              v-model="filter_request.types"
              class="w-100"
              :reduce="val => val.id"
              v-on:input="filterDataChanged"
          />
        </b-col>

        <b-col lg="4" md="12" class="mb-md-0 mb-2">
          <label>{{$t('Contracts')}}</label>
          <v-select multiple :close-on-select="false"
                 :dir="$store.getters['auth/preferDirIsRtl']  ? 'rtl' : 'ltr'"
                   
                    :getOptionLabel="c => c.name"
                    :options="contractsOptions"
                    v-model="filter_request.contracts"
                    class="w-100"
                    :reduce="val => val.id"
                     v-on:input="filterDataChanged"
          />
        </b-col>


      </b-row>
     
    </b-card-body>
  </b-card>
  
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BButton, VBToggle, BCollapse
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Filter   from './filter.js'
import FilterLogic   from './filterLogic.js'
import { ReportService } from '@/app/reports/share/report.service'
import store from '@/store'
export default {
  components: {
    BRow,BButton,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
  },
  setup(props, { emit }){
   const {filter_request,reFilter,devices}  =FilterLogic();
   const{ ownersOptions,typesOptions,categoriesOptions,contractsOptions}= Filter('device')

  
 

   const filterDataChanged =()=>{

    emit('merageFilterWithRequest', filter_request.value);
   ReportService.getDevicesOptions(
      Object.assign( filter_request.value,{
       type:'device',
       isSupport:true,
       categories:['COMPACTOR'],
       user: store.state.auth.userData.id
   
   })
     ).then(response => {
       
       devices.value = response.data.map((d)=>({id:d.device_id,"name":d.name}))
             emit('divicesFilterd', devices.value);
          
      })
     .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
     .finally(() => {})
   

   }

    return { 
    ownersOptions,
    typesOptions,
    categoriesOptions,
    contractsOptions,
    filter_request,
    filterDataChanged,
    reFilter,
    devices,ReportService

    }

  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
